import styled from "styled-components";

export const LoadingContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.shades[0]};
  border-radius: ${({ theme }) => theme.radius}px;
  padding: ${({ theme }) => theme.spacing * 4}px;
  box-shadow: ${({ theme }) => theme.boxShadow};
`;
